<script>
    export let title = "";
    export let btnStyle = "nav_bar_btn";
    export let type = "";
    export let px = "0";
    export let me = "2";
    export let href = "";
    export let border_radius = "2.070vw";
    export let padding = "2.804vw 11.682vw";
  </script>
  
  <button
    {href}
    class="{btnStyle} me-{me}"
    {type}
    style="border-radius: {border_radius}; padding: {padding};"
    on:click
  >
    <h5 class="m-0 px-{px}  fw-bold">
      {title}
    </h5>
  </button>
  
  <style>
    button {
      font-family: "Poppins", sans-serif;
      border-radius: 2.070vw;
    }
    h5 {
      font-size: 2.804vw;
    }
    .nav_bar_btn {
    background-color: #ff6d24;
      opacity: 100%;
      font-weight: 800;
      color: white;
      justify-content: center;
      align-items: center;
      display: flex;
      border: none;
    }
    .nav_bar_btn h5 {
        margin: 0;
        font-size: 2.804vw;
        font-weight: 500;
    }
    /* .submit_btn {
      background-color: white;
      opacity: 100%;
      color: #ff6d24;
      justify-content: center;
      align-items: center;
      display: flex;
      border: none;
    }
    .submit_btn:hover {
      background-color: transparent;
      border: 0.15vw solid white;
      color: white;
    }
    .submit_btn h5 {
      margin: 0;
      font-size: 1.042vw;
      font-weight: 500;
    } */
  </style>
  